import React from 'react';
import { Carousel as MaestroCarousel, useBreakpoint } from '@landr/maestro';
import { Pack, RePack } from 'types';
import Wrapper from 'components/CommonUi/Wrapper';
import { usePreviewContext } from '../contexts/PreviewContext/PreviewContext';
import PreviewWrapper from '../contexts/PreviewContext/components/PreviewWrapper';
import Preview from '../contexts/PreviewContext/components/Preview';
import Slide from './Slide';
import { SlideSkeleton } from './Slide';

const _Carousel = ({
    slides,
    isMobile,
}: {
    slides: JSX.Element[];
    isMobile: boolean;
}) => {
    return (
        <Wrapper isNegative={true}>
            <MaestroCarousel
                items={slides}
                slidesPerPage={{
                    xs: 1,
                    sm: 2,
                    md: 3,
                    lg: 4,
                    xl: 5,
                    default: 6,
                }}
                scrollToSelection={false}
                gutter="md"
                arrowOffset={56} /* @maestro-no-token */
                itemsOffset={isMobile ? 'xl' : undefined}
            />
        </Wrapper>
    );
};

const useCarousel = ({
    items,
    isLoading,
}: {
    items: Pack[] | RePack[];
    isLoading: boolean;
}) => {
    let slides: JSX.Element[];

    if (!isLoading) {
        slides = items.map((item) => {
            return <Slide key={item?.name} item={item} />;
        });
    } else {
        slides = [
            <SlideSkeleton key="slide-skeleton-1" />,
            <SlideSkeleton key="slide-skeleton-2" />,
            <SlideSkeleton key="slide-skeleton-3" />,
            <SlideSkeleton key="slide-skeleton-4" />,
            <SlideSkeleton key="slide-skeleton-5" />,
            <SlideSkeleton key="slide-skeleton-6" />,
        ];
    }

    return { slides };
};

const Carousel = ({
    items = [],
    isLoading = false,
}: {
    items?: Pack[] | RePack[];
    isLoading?: boolean;
}) => {
    const isMobile = useBreakpoint('md');
    const { slides } = useCarousel({ items, isLoading });
    const { parentRef } = usePreviewContext();

    return (
        <PreviewWrapper ref={parentRef}>
            <_Carousel slides={slides} isMobile={isMobile} />
            <Preview />
        </PreviewWrapper>
    );
};

export default Carousel;
